
import { Component, Mixins } from 'vue-property-decorator';
import NaviSerchnaviLink from '@/components/navi/NaviSerchnaviLink/';
const Words: Dictionary = {
  btn01: {
    link: '/resort/name/hotel-the-mitsui-kyoto',
    name: 'HOTEL THE MITSUI KYOTO',
  },
  btn02: {
    link: '/resort/name/harekuraini-okinawa',
    name: 'ハレクラニ沖縄',
  },
};
@Component
export default class NaviSerchnaviLinkJa extends Mixins(NaviSerchnaviLink) {
  private words = Words;
}
